export var DisclosureAcknowledgementResponse;
(function (DisclosureAcknowledgementResponse) {
    DisclosureAcknowledgementResponse["Agreed"] = "Agreed";
    DisclosureAcknowledgementResponse["NotRequired"] = "NotRequired";
    DisclosureAcknowledgementResponse["Declined"] = "Declined";
})(DisclosureAcknowledgementResponse || (DisclosureAcknowledgementResponse = {}));
export const DisclosureAcknowledgementResponseLabels = {
    Agreed: "Agreed",
    NotRequired: "Not Required",
    Declined: "Declined",
};
//# sourceMappingURL=disclosure.js.map